import { createTrignometryOperator } from "./_internal";
const $cos = createTrignometryOperator(Math.cos);
export {
  $cos
};
